import { render } from "./KoruViewer.vue?vue&type=template&id=69ad0e1b&ts=true"
import script from "./KoruViewer.vue?vue&type=script&lang=ts"
export * from "./KoruViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__